<template>
    <div class="enroll_card">
        <div class="img">
            <img :src="eventData.Image || require('@/assets/default-big.png')" />
        </div>
        <div class="title">{{eventData.Title}}</div>
        <div class="info">{{ctrltext(eventData.Introduction)}}</div>
        <div class="date">活動時間:{{showDate}}</div>
        <div class="btn_box">
            <div class="Orange_btn islogin">
                <a :href="`/Event/Index?Id=${eventData.Id}`">了解詳情</a>
            </div>
        </div>
    </div>
</template>

<script>
import Common from "@/common";
export default {
    name: "enrollcard",
    components: {},
    props: {
        eventData: {
            type: Object
        }
    },
    data() {
        return {};
    },
    methods: {
        ctrltext(text) {
            let Str = Common.Ctrltext(text, 60);
            return Str;
        }
    },
    computed: {
        showDate() {
            const vm = this;
            const StartOn = vm.eventData.RegisterStartOn
                ? vm.$moment(vm.eventData.RegisterStartOn).format("YYYY-MM-DD")
                : "";
            const EndOn = vm.eventData.RegisterEndOn
                ? " ~ " +
                  vm.$moment(vm.eventData.RegisterEndOn).format("YYYY-MM-DD")
                : "";
            return StartOn + EndOn;
        }
    },
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enroll_card {
    border: 1px solid #eee;
    line-height: 1.5;
    letter-spacing: 2px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.enroll_card .img {
    width: 100%;
    font-size: 0;
    padding-bottom: 30px;
    max-height: 190px;
    overflow: hidden;
}
.enroll_card .img img {
    width: 100%;
}
.enroll_card .title,
.enroll_card .date,
.enroll_card .info {
    padding: 10px;
    word-wrap: break-word;
}
/* .enroll_card .title,
.enroll_card .date {
  text-align: center;
} */
.enroll_card .date {
    font-size: 0.9rem;
}
.enroll_card .date,
.enroll_card .info {
    color: #666;
}
.enroll_card .title {
    min-height: 98px;
    font-size: 1.1rem;
}
.enroll_card .info {
    /* min-height: 140px; */
    flex: 1;
}
.enroll_card .btn_box {
    width: 100%;
    padding: 0 10px;
    margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/enroll/imgCard.vue